/**
 * 1-based positions in a rendered feed where promoted events are injected.
 *
 * Shared by every tab so an ad lands in the same visual slot regardless of which feed the user is on.
 */
export const PROMOTED_EVENTS_RANKS = [1, 4, 9];
